export class Project {
  constructor(
    orderPublish,
    id,
    name,
    description,
    details,
    isApplication,
    isImageVertical,
    folderImages,
    banner,
    iconImage,
    bannerImage,
    images,
    urlVideo,
    publishing,
    team
  ) {
    this.orderPublish = orderPublish;
    this.id = id;
    this.name = name;
    this.description = description;
    this.details = details;
    this.isApplication = isApplication;
    this.isImageVertical = isImageVertical;
    this.folderImages = folderImages;
    this.banner = banner;
    this.iconImage = iconImage;
    this.bannerImage = bannerImage;
    this.images = images;
    this.urlVideo = urlVideo;
    this.publishing = publishing;
    this.team = team;
  }
}
